document.addEventListener('DOMContentLoaded', () => {
  const managedVideos = [...document.querySelectorAll('video[autoplay]')];
  const loadVideo = (video) => {
    if (video.dataset.loaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.loaded = 'true';
    video.load();
  };

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          loadVideo(video);
          if (video.autoplay) video.play().catch(() => {});
        } else if (video.autoplay && video.dataset.loaded === 'true') {
          video.pause();
        }
      });
    }, { threshold: 0.15 });
    managedVideos.forEach((video) => videoObserver.observe(video));
  } else {
    managedVideos.forEach((video) => {
      loadVideo(video);
      if (video.autoplay) video.play().catch(() => {});
    });
  }

  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-carousel-track]');
    const slides = [...gallery.querySelectorAll('.os-product__slide')];
    const dots = [...gallery.querySelectorAll('[data-carousel-dot]')];
    if (!track || slides.length < 2) return;

    const setActiveSlide = (index, scroll = false) => {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === safeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (scroll) track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => setActiveSlide(Number(dot.dataset.carouselDot), true));
    });

    let frame;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setActiveSlide(index);
      });
    }, { passive: true });

    gallery.showMedia = (mediaId) => {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0) setActiveSlide(index, true);
    };
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('.os-product-form');
    const variantSelect = form?.querySelector('[data-variant-select]');
    const groups = [...(form?.querySelectorAll('[data-option-group]') || [])];
    if (!form || !variantSelect) return;

    const updateVariant = (variantOption) => {
      if (!variantOption) return;
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const saving = section.querySelector('[data-product-saving]');
      const stock = section.querySelector('[data-product-stock]');
      const button = section.querySelector('[data-add-to-cart]');
      const gallery = section.querySelector('[data-product-gallery]');
      const available = variantOption.dataset.available === 'true';

      variantSelect.value = variantOption.value;
      if (price) price.textContent = variantOption.dataset.price || '';
      if (compare) {
        compare.textContent = variantOption.dataset.comparePrice || '';
        compare.hidden = !variantOption.dataset.comparePrice;
      }
      if (saving) {
        saving.textContent = variantOption.dataset.saving || '';
        saving.hidden = !variantOption.dataset.saving;
      }
      if (stock) {
        stock.textContent = available ? stock.dataset.availableText : stock.dataset.unavailableText;
        stock.classList.toggle('is-unavailable', !available);
      }
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }
      if (variantOption.dataset.mediaId && gallery?.showMedia) gallery.showMedia(variantOption.dataset.mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantOption.value);
      window.history.replaceState({}, '', url);
    };

    groups.forEach((group) => {
      group.addEventListener('change', () => {
        const selected = group.querySelector('input:checked');
        const label = group.querySelector('[data-selected-option]');
        if (label && selected) label.textContent = selected.value;

        const selectedValues = groups.map((item) => item.querySelector('input:checked')?.value);
        const match = [...variantSelect.options].find((option) => {
          try {
            return JSON.parse(option.dataset.options || '[]').every((value, index) => value === selectedValues[index]);
          } catch {
            return false;
          }
        });
        updateVariant(match);
      });
    });
  });
});
